// extracted by mini-css-extract-plugin
export default {"card":"AddNote_card__1yUCM","form-control":"AddNote_form-control__67fRC","btn":"AddNote_btn__yZlEW"};